import './FooterLinks.scss';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CButton } from '@/components/CButton';

export const FooterLinks = () => {
  const { t } = useTranslation(['pages/login']);
  const navigate = useNavigate();

  return (
    <div className="c-login__footer-links">
      <span className="c-login__footer-meta">
        &copy; {new Date().getFullYear()} {t('pages/login:pages.login.footer.copyright')}
      </span>
      <CButton variant="link" size="sm" onClick={() => navigate('/privacy-policy')}>
        {t('pages/login:pages.login.footer.privacy_policy')}
      </CButton>
      <CButton variant="link" size="sm" onClick={() => navigate('/terms-of-service')}>
        {t('pages/login:pages.login.footer.terms_of_service')}
      </CButton>
    </div>
  );
};
